<template>
  <div class="localization">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebarPromotion></layout-sidebarPromotion>
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <div class="row">
            <div class="col-md-12">
              <!-- Page Header -->
              <div class="page-header">
                <div class="row">
                  <!-- {{profileArr}} -->
                  <div class="col-sm-12">
                    <h3 class="page-title">Link - Affiliate Program</h3>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-8">
                          <div class="form-group row">
                            <div class="input-group" style="margin-left:10px;">
                              <input
                                :value="referralLink"
                                type="text"
                                class="form-control js-copytextarea"
                                placeholder
                                aria-label
                                aria-describedby="basic-addon2"
                                readonly
                              />
                              <div class="input-group-append">
                                <button type="button" class="btn btn-white js-textareacopybtn">
                                  <i class="fa fa-copy"></i> Copy
                                </button>
                              </div>
                            </div>
                          </div>
                          <p>
                            <b>Your Referral Code: {{infoArr.referral_code}}</b>
                            <br />
                            <b>Comission: {{infoArr.referral_bonus*100}}%</b>
                            <br />
                            <span class="text-muted">Get bonuses by referring members.</span>
                          </p>
                        </div>
                        <div class="col-md-4 text-center">
                          <qrcode-vue :value="referralLink" :size="100" level="H" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <template v-if="imgArr.length">
                <h4>Promotional Material</h4>
                <div class="row row-sm">
                  <div
                    v-for="(imgLink,idx) in imgArr"
                    :key="idx"
                    class="col-6 col-sm-4 col-md-3 col-lg-4 col-xl-3"
                  >
                    <div class="card card-file">
                      <div class="dropdown-file">
                        <a href class="dropdown-link" data-toggle="dropdown">
                          <i class="fa fa-ellipsis-v"></i>
                        </a>
                        <div class="dropdown-menu dropdown-menu-right">
                          <a target="_blank" :href="imgLink" class="dropdown-item">
                            <i class="fa fa-eye"></i>&nbsp;View
                          </a>
                          <a
                            @click="downloadImage(imgLink,'pm-waajo-'+idx)"
                            href="javascript:void(0)"
                            class="dropdown-item"
                          >
                            <i class="fa fa-download"></i>&nbsp;Download
                          </a>
                        </div>
                      </div>
                      <div class="text-center">
                        <img :src="imgLink" :style="'width:80%;'" />
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>

<script>
import LayoutHeader from "@/components/layouts/Header.vue";
// import LayoutSidebarPromotion from "@/components/layouts/SidebarPromotion.vue";
import LayoutSidebarPromotion from "@/components/layouts/Sidebar.vue";

import VueSimpleAlert from "vue-simple-alert";
import { downloadImage } from "@/utils/helper";
import QrcodeVue from "qrcode.vue";

export default {
  components: {
    LayoutHeader,
    LayoutSidebarPromotion,
    QrcodeVue
  },
  computed: {
    memberSession() {
      return this.$store.state.login.memberSession;
    },
    isJoinAffiliate() {
      return this.$store.state.referral.isJoin;
    }
  },
  data() {
    return {
      appTitle: process.env.VUE_APP_TITLE,
      isLoading: false,
      isLoadingImages: false,
      isLoadingInfo: false,
      referralLink: "",
      imgArr: [],
      infoArr: {
        id: 0,
        referral_code: "",
        referral_join_datetime: 0,
        referral_bonus: 0,
        target_omzet: 0,
        update_datetime: 0
      }
    };
  },
  async created() {
    this.info();
    this.shareLink();
    this.images();
    if (this.isJoinAffiliate == false) {
      this.$router.push({ path: "/referral" });
    }
  },
  methods: {
    downloadImage(url, title) {
      return downloadImage(url, title);
    },
    info() {
      this.isLoadingInfo = true;
      this.$store
        .dispatch("referral/info")
        .then(response => {
          this.isLoadingInfo = false;
          this.infoArr = response.data;
        })
        .catch(() => {
          this.isLoadingInfo = false;
        });
    },
    images() {
      this.isLoadingImages = true;
      this.$store
        .dispatch("referral/images")
        .then(response => {
          this.isLoadingImages = false;
          this.imgArr = response.data;
        })
        .catch(() => {
          this.isLoadingImages = false;
        });
    },
    shareLink() {
      this.isLoading = true;
      this.$store
        .dispatch("referral/shareLink")
        .then(response => {
          this.isLoading = false;
          this.referralLink = response.data;
        })
        .catch(() => {
          this.isLoading = false;
        });
    }
  },
  mounted() {
    var copyTextareaBtn = document.querySelector(".js-textareacopybtn");

    copyTextareaBtn.addEventListener("click", function(event) {
      var copyTextarea = document.querySelector(".js-copytextarea");
      copyTextarea.focus();
      copyTextarea.select();

      try {
        var successful = document.execCommand("copy");
        var msg = successful ? "successful" : "unsuccessful";
        if (successful) {
          VueSimpleAlert.fire({
            title: "Success",
            text: "Copied successfully!",
            type: "success",
            timer: 3000
          });
        }
        // console.log("Copying text command was " + msg);
      } catch (err) {
        // console.log("Oops, unable to copy");
        VueSimpleAlert.fire({
          title: "Success",
          text: "Copied successfully!",
          type: "success",
          timer: 3000
        });
      }
    });

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "referral"
};
</script>


// WEBPACK FOOTER //
// src/views/referral/link.vue